const form = document.querySelector('#searchform')
const btn = document.querySelector('#searchform button')
const input = document.querySelector('#searchform input')

const openSearch = () => {
    form.classList.add('active')
    input.focus()
    btn.setAttribute('type', 'submit')
}

/**
 * 
 * @param {FocusEvent|KeyboardEvent} evt 
 * @param {boolean} isKeyBoard 
 */
const closeSearch = (evt, isKeyBoard) => {
    if(isKeyBoard || (evt.relatedTarget === null || evt.relatedTarget.nodeName !== 'BUTTON')) {
        form.classList.remove('active')  
        btn.setAttribute('type', 'button')
    }
}

btn?.addEventListener('click', evt => {
    const type = btn.getAttribute('type')
    if(type === 'button') {
        evt.preventDefault()
        openSearch(evt)
    }
})

window.addEventListener('keydown', evt => {
    if (['k', ' '].includes(evt.key) && evt.ctrlKey === true) {
        evt.preventDefault()
        openSearch()
    }

    if(evt.key === "Escape") {
        closeSearch(evt, true)
    }
})

input?.addEventListener('blur', closeSearch)
